import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tab"]
    static values = {
        activeClass:   { type: String, default: "bg-red-1200" },
        inactiveClass: { type: String, default: "bg-blue-800/80" }
    }

    connect() {
        if (this.hasTabTarget) {
            this.activateTab(this.tabTargets[0].dataset.tabName)
        }
    }

    switch(event) {
        event.preventDefault()
        this.activateTab(event.currentTarget.dataset.tabName)
    }

    activateTab(tabName) {
        const active   = this.activeClassValue.split(" ")
        const inactive = this.inactiveClassValue.split(" ")

        this.tabTargets.forEach((tab) => {
            if (tab.dataset.tabName === tabName) {
                tab.classList.add(...active)
                tab.classList.remove(...inactive)
            } else {
                tab.classList.remove(...active)
                tab.classList.add(...inactive)
            }
        })

        this.element.querySelectorAll("[data-tab-content]").forEach((content) => {
            content.classList.toggle("hidden", content.dataset.tabContent !== tabName)
        })
    }
}
